import React, { Component } from 'react'
import { Config } from '../Config';
import Loading from './Loading';
import $ from 'jquery'

function getCurrentMenu(html) {
    $("#nav-menu-item-17765 a:first", html).removeClass("current");

    if (Config.basename === "/concursos/") {
        $("#nav-menu-item-15054 a:first", html).addClass("current");
    }
    if (Config.basename === "/avaliacoes/") {
        $("#nav-menu-item-19597 a:first", html).addClass("current");
    }
    if (Config.basename === "/certificacoes/") {
        $("#nav-menu-item-19671 a:first", html).addClass("current");
    }
    if (Config.basename === "/pas/" || Config.basename === "/vestibulares/") {
        $("#nav-menu-item-15055 a:first", html).addClass("current");
    }
}

class Menu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menus: [],
            loading: true
        }
    }

    componentDidMount() {
        let url = `${Config.apiLink}menus/${this.props.identificador}`;
        const urlIndexHtml = "../index.html";
        $.get(urlIndexHtml, (data) => {

            var html = $(data);

            getCurrentMenu(html);

            var navDesktop = $('.main_menu', html);
     
            var navMobile = $('.mobile_menu', html);     

            this.setState({
                navDesktop: navDesktop.html(),
                navMobile: navMobile.html(),
                loading: false
            });    

            setTimeout(function () {

                //let x = 0;
                //while (x < document.querySelector(".main_menu > ul").children.length) {

                //    document.querySelector(".main_menu > ul").children[x].addEventListener("mouseenter", function () {
                //        this.children[1].className += " drop_down_start";
                //    });

                //    document.querySelector(".main_menu > ul").children[x].addEventListener("mouseleave", function () {
                //        this.children[1].classList.remove("drop_down_start");
                //    });

                //    x++
                //}

            }.bind(this), 2000);
        });
    
        //$.ajax({
        //    url: url,
        //    dataType: 'json',
        //    cache: false,
        //    success: (result) => {        

        //        this.setState({ menus: result.items, loading: false });
        //        setTimeout(function () {
                   
        //            let x = 0;
        //            while (x < document.querySelector(".main_menu > ul").children.length) {

        //                document.querySelector(".main_menu > ul").children[x].     ("mouseenter", function () {
        //                    this.children[1].className += " drop_down_start";
        //                });

        //                document.querySelector(".main_menu > ul").children[x].addEventListener("mouseleave", function () {
        //                    this.children[1].classList.remove("drop_down_start");
        //                });

        //                //console.log(x)
        //                x++
        //            }
        //        }.bind(this), 2000)
        //    }
        //});
    }

    render() {

        var url = window.location.href; 

        const { loading } = this.state;
        if (loading) {
            return (<Loading></Loading>);
        }
       
        return (

            <div>
                <nav className="main_menu drop_down right" dangerouslySetInnerHTML={{ __html: this.state.navDesktop }}></nav>
                <nav className="mobile_menu" dangerouslySetInnerHTML={{ __html: this.state.navMobile }}></nav>
            </div>

        )
    }
}

export default Menu













